import parse from 'html-react-parser';
import React, { FC } from 'react';

import { SolutionType } from '../../types';
import ThemeLink from '../theme-link/theme-link';

type PropType = {
  className: string;
} & SolutionType;

const ThemeEmployerHelpItem: FC<PropType> = ({ className, title, description, externalLink }) => (
  <div className={className}>
    <h4>{title}</h4>
    <p>{parse(description ?? '')}</p>
    {externalLink && <ThemeLink {...externalLink} />}
  </div>
);

export default ThemeEmployerHelpItem;
